import * as Apple1 from './apple1';

window.Apple1 = Apple1;
